module.exports = __webpack_public_path__ + "static/media/PDF16.6f05b13c.pdf";